import React from 'react';
import styles from '../FeatureIconEditor.module.scss';


function NoUserIconData() {
  return (
    <div className={styles.noUserData}>
      <p className={styles.noUserContent}>
        It looks like you have no favorite icons.
      </p>
    </div>
  );
}

export default NoUserIconData